// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "大学物理（下)",
      "tec": "杜春艳",
      "week": "1-14周",
      "add": "教学楼A座321电力"
    },
    {
      "sub": "概率论与数理统计",
      "tec": "王琪",
      "week": "1-14,17-18周",
      "add": "教学楼C座311教务"
    },
    {
      "sub": "科技应用文写作与沟通艺术",
      "tec": "于丹丹",
      "week": "1-14,17-18周",
      "add": "教学楼C座213教务"
    },
    {
      "sub": "形势与政策",
      "tec": "单超",
      "week": "1-4周",
      "add": "教学楼C座114教务"
    },
    0
  ],
  "2": [
    0,
    {
      "sub": "电路",
      "tec": "姜竹楠",
      "week": "1-14,17-18周",
      "add": "教学楼A座320电力"
    },
    {
      "sub": "工程制图与CAD",
      "tec": "张晨晨",
      "week": "1-14,17-18周",
      "add": "教学楼A座320电力"
    },
    {
      "sub": "电路实验",
      "tec": "李媛媛",
      "week": "1-12周",
      "add": "实训楼A座204"
    },
    {
      "sub": "就业创业指导",
      "tec": "赵毅王刚王祎雪刘东岩",
      "week": "9-12周",
      "add": "大活礼堂"
    }
  ],
  "3": [
    {
      "sub": "中国近现代史纲要",
      "tec": "黄玉兰",
      "week": "1-12周",
      "add": "教学楼B座124自控"
    },
    {
      "sub": "大学物理（下)",
      "tec": "杜春艳",
      "week": "1-14周",
      "add": "教学楼A座321电力"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "电路",
      "tec": "姜竹楠",
      "week": "1-14,17-18周",
      "add": "教学楼A座226电力"
    },
    [
      {
        "sub": "体育（三）",
        "tec": "李欣诺",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男网",
        "tec": "李庆",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "轮滑",
        "tec": "贾思敏",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男篮",
        "tec": "张慧",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "健美操",
        "tec": "郝俊",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "女排",
        "tec": "姚宝剑",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男篮",
        "tec": "樊绍斌",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男篮",
        "tec": "李罡",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "足球",
        "tec": "张凯",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "足球",
        "tec": "王莹莹",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "女网",
        "tec": "朱永",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男羽",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "搏击",
        "tec": "高佳",
        "week": "1-18周",
        "add": "男乒"
      }
    ],
    0,
    {
      "sub": "数字电子技术",
      "tec": "张玉梅",
      "week": "1-14,17-18周",
      "add": "教学楼A座116电力"
    },
    0
  ],
  "5": [
    {
      "sub": "复变函数与积分变换",
      "tec": "于智慧",
      "week": "1-14,17-18周",
      "add": "教学楼C座213教务"
    },
    {
      "sub": "中国近现代史纲要",
      "tec": "黄玉兰",
      "week": "1-12周",
      "add": "教学楼B座124自控"
    },
    {
      "sub": "概率论与数理统计",
      "tec": "王琪",
      "week": "1-14,17-18双周",
      "add": "教学楼C座114教务"
    },
    {
      "sub": "电路",
      "tec": "姜竹楠",
      "week": "1-14,17-18周",
      "add": "教学楼A座320电力"
    },
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
